import React, {Component, PropTypes} from 'react';
import {Link, browserHistory} from "react-router";

var moment = require('moment');

var clearFlag = false;
import {ellaUrl} from '../../../path.config'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'COMPONENT/tip'
import userService from 'SERVICES/ella/userService'
import {resultTip,language} from 'UTIL/common'
const roleList = [];
import ellaService from 'SERVICES/purifier/ella/ellaService'
export default class UserEdit extends Component {
    constructor(props) {
        super(props);
        this.btnSubmit = this.btnSubmit.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.fetchExtendsValue = this.fetchExtendsValue.bind(this);
        this.clearCheckedOldNodes = this.clearCheckedOldNodes.bind(this);
        this.createTree = this.createTree.bind(this);
        this.count = this.count.bind(this);
        this.state = {
            id: this.props.params.id,
            userBase: {},
            roleList: [],
            userType: [],
            selectRole: [],
            extendsValue: [],
            url: ellaUrl
        };
    }

    onCheck(e, treeId, treeNode) {
        this.count();
        if (clearFlag) {
            this.clearCheckedOldNodes();
        }
    }

    clearCheckedOldNodes() {
        var zTree = $.fn.zTree.getZTreeObj("treeDemo"),
            nodes = zTree.getChangeCheckedNodes();
        for (var i = 0, l = nodes.length; i < l; i++) {
            nodes[i].checkedOld = nodes[i].checked;
        }
    }

    count() {
        var zTree = $.fn.zTree.getZTreeObj("treeDemo"),
            checkCount = zTree.getCheckedNodes(true).length,
            nocheckCount = zTree.getCheckedNodes(false).length,
            changeCount = zTree.getChangeCheckedNodes().length;
        $("#checkCount").text(checkCount);
        $("#nocheckCount").text(nocheckCount);
        $("#changeCount").text(changeCount);
    }

    createTree(setting, orgList) {
        $.fn.zTree.init($("#treeDemo"), setting, orgList);
        this.count();
        clearFlag = $("#last").attr("checked");
    }

    //照片预览
    imgPreview(id, fileDom) {
        // 判断是否支持FileReader
        fileDom = fileDom.target;
        if (window.FileReader) {
            var reader = new FileReader();
        } else {
            alert("您的设备不支持图片预览功能，如需该功能请升级您的设备！");
        }
        //获取文件
        var file = fileDom.files[0];
        var imageType = /^image\//;
        //是否是图片
        if (!imageType.test(file.type)) {
            alert("请选择图片！");
            return;
        }
        //读取完成
        reader.onload = function (e) {
            //获取图片dom
            var img = document.getElementById("preview" + id);
            //图片路径设置为读取的图片
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    }

    componentDidMount() {
        var id = this.state.id;
        ellaService.userToUpdate(id).then(data=>{
            if (data.data != null) {
                var userBase = data.data.userBase;
                var nodeVos = JSON.parse(data.data.nodeVos);
                var roleList = data.data.roleList;
                var selectRole = data.data.selectRole;
                var orgs = data.data.orgs;
                var userType = data.data.userType;
                var userExtendValues = data.data.userExtendValues;


                this.setState({
                    map: data.data,
                    userBase: data.data.userBase,
                    roleList: data.data.roleList,
                    dvcTypes: userBase.dvcTypes,
                    selectRole: selectRole,
                    userType: userType,
                    userExtendValues: userExtendValues,
                })
                this.fetchExtendsValue(userBase.userTypeId);

                $("#loginName").val(userBase.loginName);
                $("#realName").val(userBase.realName);
                $("#telephone").val(userBase.telephone);
                $("#email").val(userBase.email);
                $("#address").val(userBase.address);
                $("#telephone").val(userBase.telephone);
                if (userBase.endTime != null) {
                    $("#endTime").val(userBase.endTime.substring(0, 10));
                }
                $("#userTypeId").val(userBase.userTypeId);

                //组织架构
                var setting = {
                    check: {
                        enable: true,
                        chkStyle: "radio",
                        radioType: "all"
                    },
                    data: {
                        simpleData: {
                            enable: true
                        }
                    },
                    callback: {
                        onCheck: this.onCheck
                    }
                };
                var orgList = [];
                if (nodeVos != null) {
                    for (const i in nodeVos) {
                        var flag = false;
                        if (orgs != null && nodeVos[i].id == orgs.id) {
                            if (nodeVos[i].pId == orgs.pId) {
                                flag = true;
                                open = true;
                            }
                        }

                        let arr = {
                            id: nodeVos[i].id,
                            pId: nodeVos[i].pId,
                            name: nodeVos[i].name,
                            checked: flag,
                            open:open,
                        }
                        orgList.push(arr);
                    }
                }

                this.createTree(setting, orgList);
                $("#init").bind("change", this.createTree(setting, orgList));
                $("#last").bind("change", this.createTree(setting, orgList));

                if (userExtendValues != null) {
                    this.setState({
                        extendsValue: userExtendValues,
                    })
                }
            }
        })
    }

    // componentDidUpdate(){
    //     var userExtendValues = JSON.parse(this.state.userExtendValues);
    //     var userType = this.state.userType;
    //     console.log(userExtendValues);
    //     //扩展属性
    //     if (userType != null) {
    //         userExtendValues.map(function (userExtend) {
    //             if(userType !=5 || userType !=6 ||userType !=8){
    //                 $("#"+userExtend.extendId).val(userExtend.extendValue);
    //             }
    //         })
    //     }
    //     console.log(map);
    // }
    fetchExtendsValue(typeId) {
        $.ajax({
            type: "GET",
            url: this.state.url + "/userextends/list/" + typeId,
            success: function (data) {
                var value = data.data;
                if (value != null) {
                    var extendsValue = value.page.records;
                    this.setState({
                        extendsValue: extendsValue,
                    })
                }
            }.bind(this),
            error: function () {
                console.log("submit error");
            }.bind(this),
        });
    }

    onchange() {
        var typeId = $("#userTypeId").val();
        if (typeId == 2) {
            $("#org").hide();
        } else {
            $("#org").show();
        }
        this.fetchExtendsValue(typeId);
    }

    btnSubmit() {
        var id = this.state.id;
        var remark = $("#remark").val();

        var loginName = $("#loginName").val().trim();
        var realName = $("#realName").val().trim();
        var telephone = $("#telephone").val().trim();
        var email = $("#email").val().trim();
        var address = $("#address").val().trim();
        var endTime = $("#endTime").val();
        var userTypeId = $("#userTypeId option:selected").val();


        var zTree = $.fn.zTree.getZTreeObj("treeDemo");
        var org = zTree.getCheckedNodes();

        if (org != null && org.length > 0) {
            var length = org.length;
            var orgNodeId = org[length - 1].id;
        }

        var chk_value = [];
        $('input[id="roleType"]:checked').each(function () {
            chk_value.push($(this).val());
        });
        //扩展属性
        var extendsValue = [];
        $("input[name='extendsValue']").each(function () {
            var result = "";
            if (this.value != null) {
                result = this.value;
            }
            var str = this.id + ":" + result;
            extendsValue.push(str);
        });
        var data = {
            id: id,
            loginName: loginName,
            realName: realName,
            telephone: telephone,
            email: email,
            address: address,
            orgs: orgNodeId,
            roles: chk_value.toString(),
            endTime: endTime,
            extendsValue: extendsValue,
            userTypeId: userTypeId,
        };
        console.log(JSON.stringify(data));

        var userBody  = JSON.stringify(data);
        userService.saveUser({userBody}).then(data =>{
            resultTip(data,"/ella/user/user/userList");
        })
    }

    //文件上传处理
    uploadHandle(id, fileDom) {
        if (!window.FormData) {
            $("#msg").html("你的浏览器不支持。");
            $(".alert").show();
        }
        //获得原生的form表单对象，等价于document.forms[0]
        var form = document.getElementById("uploadForm" + id);
        if (form == null) {
            return;
        }
        //单个文件超过400MB就不再上传
        var hasError = false;
        var fileName = "";
        $("input[type='file']", form).each(function (index, file) {
            if (file.files.length > 0) {
                fileName = file.files[0].name;
                if (file.files[0].size > 400 * 1024 * 1024) {
                    $("#msg").html("单个文件不能超过400MB。");
                    $(".alert").show();
                    hasError = true;
                    return;
                }
            }
        });
        if (hasError) {
            return;
        }
        //构造FormData对象用于发送数据
        var formData = new FormData(form);
        var xhr = new XMLHttpRequest();
        if (null == form.action) {
            return;
        }
        xhr.open("post", form.action, true);

        //设置请求超时
        xhr.upload.timeout = 2000;
        xhr.upload.ontimeout = function (event) {
            $("#msg").html("请求超时！");
            $(".alert").show();
        };
        //添加progress事件
        xhr.upload.addEventListener("progress", function (e) {
            $(".progress-bar" + id).addClass("active");
            var howMuch = e.loaded / e.total;
            var p = parseFloat((howMuch * 100).toFixed(2)) + "%";
            $(".progress-bar" + id).css("width", p).html(p);
        }, false);
        //上传完成
        xhr.upload.addEventListener("load", function (event) {
            $("#" + id).val(fileName);
            $(".progress-bar" + id).removeClass("active");
            $("#msg").html("上传完成！");
            $(".alert").show();
        }, false);
        xhr.upload.addEventListener("error", function (event) {
            $(".progress-bar" + id).removeClass("active");
            $("#msg").html("上传出错！");
            $(".alert").show();
        }, false);
        xhr.upload.addEventListener("abort", function (event) {
            $(".progress-bar" + id).removeClass("active");
            $("#msg").html("您取消了本次上传。");
            $(".alert").show();
        }, false);
        xhr.send(formData);
    }

    //单选框
    getRadio(id, str, fileDom) {
        $("#" + id).val(str.split("=")[1]);
    }

    //下拉框
    selectChange(id, fileDom) {
        $("#" + id).val($("#select" + id).val());
    }

    //多选框
    changeCheckbox(ids, fileDom) {
        var str = "name='checkbox" + ids + "'";
        var aa = "";
        $("input[" + str + "]:checkbox:checked").each(function () {
            aa += "," + $(this).val()
            console.log(aa);
        })
        $("#" + ids).val(aa + ",");
    }

    render() {
        const _this = this;
        var selectrole = this.state.selectRole;
        const roleList = this.state.roleList.map(function (str, index) {
            var div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox"></input>
                <span className="checkbox-body"></span>
                <span className="checkbox-text">{str.roleName}</span></div>;
            if (selectrole != null && selectrole.indexOf(str.id) != -1)
                div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox" checked></input>
                    <span className="checkbox-body"></span>
                    <span className="checkbox-text">{str.roleName}</span></div>;

            return div;
        });

        const userType = this.state.userType.map(function (str, index) {
            return <option value={str.id}>{str.name}</option>
        })

        // 扩展属性

        const extend = this.state.extendsValue.map(function (str, index) {
            if (str.formType == 0) {
                //文本框
                return <div className="form-group col-sm-6">
                    <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                    <div className="col-xs-6">
                        <input type="text" className="form-control" id={str.id} name="extendsValue"
                               defaultValue={str.extendValue}/>
                    </div>
                </div>;
            } else if (str.formType == 1) {
                //区域框
                return <div className="form-group col-sm-6">
                    <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                    <div className="col-xs-4">
                        <textarea cols="49" rows="3" style={{padding: "6px 12px"}} id={str.id}></textarea>
                    </div>
                </div>;
            } else if (str.formType == 2) {
                //文件
                return <div className="form-group col-sm-6">
                    <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                    <div className="col-xs-6">
                        <form id={"uploadForm" + str.id} action="http://10.18.11.67:9011/challenger/file/upload"
                              method="post"
                              enctype="multipart/form-data">
                            <div className="input-group">
                                <input name="file" type="file" className="form-control"
                                       aria-describedby="basic-addon1" value={str.extendValue}/>
                            </div>
                            <p></p>
                            <div className="progress">
                                <div
                                    className={"progress-bar" + str.id + " progress-bar-danger progress-bar-striped active"}
                                    role="progressbar" aria-valuemin="0" aria-valuemax="100" style={{width: "0%"}}>
                                    0%
                                </div>
                            </div>
                            <div class="alert alert-danger alert-dismissable" style={{display: "none"}}>
                                <button type="button" class="close" onclick="$('.alert').hide();"
                                        aria-hidden="true">
                                    &times;
                                </button>
                                <span id="msg">错误！请进行一些更改。</span>
                            </div>
                        </form>
                        <input type="hidden" id={str.id} name="extendsValue" defaultValue={str.extendValue}/>
                        <div>
                            <button type="button" onClick={_this.uploadHandle.bind(this, str.id)}
                                    className="btn btn-primary"
                                    autocomplete="off">上传
                            </button>
                        </div>
                    </div>
                </div>;
            } else if (str.formType == 3) {
                //密码框
                return <div className="form-group col-sm-6">
                    <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                    <div className="col-xs-4">
                        <input type="password" id={str.id} name="extendsValue" defaultValue={str.extendValue}/>
                    </div>
                </div>;
            } else if (str.formType == 4) {
                //图片
                return <div className="form-group col-sm-6">
                    <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                    <div className="col-xs-6">
                        <img id={"preview" + str.id} style={{height: "200", width: "200"}}
                             src={"http://10.18.11.67:9011/challenger/" + str.extendValue}/>
                        <form id={"uploadForm" + str.id} action="http://10.18.11.67:9011/challenger/file/upload"
                              method="post"
                              enctype="multipart/form-data">
                            <div className="input-group">
                                <input name="file" type="file" className="form-control"
                                       aria-describedby="basic-addon1" onChange={_this.imgPreview.bind(this, str.id)}/>
                            </div>
                            <p></p>
                            <div className="progress">
                                <div
                                    className={"progress-bar" + str.id + " progress-bar-danger progress-bar-striped active"}
                                    role="progressbar" aria-valuemin="0" aria-valuemax="100" style={{width: "0%"}}>
                                    0%
                                </div>
                            </div>
                            <div class="alert alert-danger alert-dismissable" style={{display: "none"}}>
                                <button type="button" class="close" onclick="$('.alert').hide();"
                                        aria-hidden="true">
                                    &times;
                                </button>
                                <span id="msg">错误！请进行一些更改。</span>
                            </div>
                        </form>
                        <input type="hidden" id={str.id} name="extendsValue" defaultValue={str.extendValue}/>
                        <div>
                            <button type="button" onClick={_this.uploadHandle.bind(this, str.id)}
                                    className="btn btn-primary"
                                    autocomplete="off">上传
                            </button>
                        </div>
                        <br />
                    </div>
                </div>
            } else if (str.formType == 5) {
                //下拉框
                if (str.content != null) {
                    const list = str.content.split("，");
                    const div = list.map(function (value) {
                        if (str.extendValue == value.split("=")[0]) {
                            return <option value={value.split("=")[0]}
                                           selected="selected">{value.split("=")[1]}</option>;
                        } else {
                            return <option value={value.split("=")[0]}>{value.split("=")[1]}</option>;
                        }
                    })

                    return <div className="form-group col-sm-6">
                        <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                        <div className="col-xs-4">
                            <select id={"select" + str.id} className="form-control"
                                    onChange={_this.selectChange.bind(this, str.id)}>
                                {div}
                            </select>
                        </div>
                        <input type="hidden" id={str.id} name="extendsValue" defaultValue={str.extendValue}/>
                    </div>;
                }
            } else if (str.formType == 6) {
                //复选框
                if (str.content != null) {
                    const list = str.content.split("，");
                    const div = list.map(function (index) {
                        if (str.extendValue !=null && str.extendValue.indexOf("," + index.split("=")[0] + ",") != -1) {
                            return <div className="col-xs-7"><input className="input-hidden" id={"checkbox" + str.id}
                                                                    name={"checkbox" + str.id}
                                                                    value={index.split("=")[0]} type="checkbox"
                                                                    defaultChecked
                                                                    onClick={_this.changeCheckbox.bind(this, str.id)}></input>
                                <span className="checkbox-body"></span>
                                <span className="checkbox-text">{index.split("=")[1]}</span></div>;
                        } else {
                            return <div className="col-xs-7"><input className="input-hidden" id={"checkbox" + str.id}
                                                                    name={"checkbox" + str.id}
                                                                    onClick={_this.changeCheckbox.bind(this, str.id)}
                                                                    value={index.split("=")[0]} type="checkbox"></input>
                                <span className="checkbox-body"></span>
                                <span className="checkbox-text">{index.split("=")[1]}</span></div>;
                        }

                    })

                    return <div className="form-group col-sm-6">
                        <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                        <div className="col-xs-7" style={{marginBottom: "15px"}}>
                            {div}
                            <input type="hidden" id={str.id} name="extendsValue" defaultValue={str.extendValue}/>
                        </div>
                    </div>
                }
            } else if (str.formType == 7) {
                //时间
                return <div className="form-group col-sm-6">
                    <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                    <div className="col-xs-5" style={{marginBottom: "15px"}}>
                        <input type="date" className="form-control" name="extendsValue" id={str.id}
                               defaultValue={str.extendValue}/>
                    </div>
                </div>;
            } else if (str.formType == 8) {
                //单选框
                const list = str.content.split("，");
                const div = list.map(function (index) {
                    if (index.split("=")[1] == str.extendValue) {
                        return <div className="col-xs-5"><input name={str.id + "radio"} className="input-hidden"
                                                                id={index.split("=")[0]}
                                                                value={index.split("=")[0]} type="radio"
                                                                defaultChecked="true"
                                                                onClick={_this.getRadio.bind(this, str.id, index)}></input>
                            <span className="checkbox-body"></span><span
                                className="checkbox-text">{index.split("=")[1]}</span></div>;
                    } else {
                        return <div className="col-xs-5"><input name={str.id + "radio"} className="input-hidden"
                                                                id={index.split("=")[0]}
                                                                value={index.split("=")[0]} type="radio"
                                                                onClick={_this.getRadio.bind(this, str.id, index)}></input>
                            <span className="checkbox-body"></span><span
                                className="checkbox-text">{index.split("=")[1]}</span></div>;
                    }
                })
                return <div className="form-group col-sm-6">
                    <label className="multi-label control-label col-xs-3">{str.attributeName}</label>
                    <div className="col-xs-7" style={{marginBottom: "15px"}}>
                        {div}
                        <input type="hidden" id={str.id} name="extendsValue" defaultValue={str.extendValue}/>
                    </div>
                </div>
            }

        })

        return (
            <div >
                <section className="content-header ">
                    <h1> 用户信息管理
                        <small>编辑用户信息</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">编辑用户信息</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids="" />
                            <form id="micaFrom" className="form-horizontal">
                                <FormInput name="loginName" id="loginName"/>
                                <FormInput name="realName" id="realName"/>
                                <FormInput name="telephone" id="telephone"/>
                                <FormInput name="email" id="email"/>
                                <FormInput name="address" id="address"/>
                                <div className="row form-group">
                                    <label  className="multi-label control-label col-xs-2">用户类型</label>
                                    <div className="col-xs-3">
                                        <select  className="form-control" id="userTypeId" onChange={this.onchange.bind(this)}>
                                            {userType}
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group" id="org">
                                    <label className="multi-label control-label col-xs-2">组织架构</label>
                                    <div className="col-xs-3">
                                        <ul id="treeDemo" className="ztree"></ul>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">有效期</label>
                                    <div className="col-xs-3" >
                                        <input type="date" className="form-control" placeholder="" id="endTime"/>
                                    </div>
                                    <span className = "">
                                          <span id={"error_endTime"}  name="success" ></span>
                                          <span className = ""></span>
                                    </span>
                                    <p className="form-control-static text-danger">
                                        <span style={{fontSize: "20px"}}>*</span>
                                    </p>
                                </div>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">选择角色</label>
                                    <div className="col-xs-10" style={{marginBottom: "15px"}}>
                                        {roleList}
                                    </div>
                                </div>
                                <div className="extends" id="extends">
                                    {extend}
                                </div>
                                <div className="row form-group">
                                    <div className="col-xs-2"></div>
                                    <div className="col-xs-1 text-center">
                                        <a className="btn btn-success" onClick={this.btnSubmit}>提交</a>
                                    </div>
                                    <div className="col-xs-1 text-center">
                                        <Link to="/ella/user/user/userList" className="btn btn-default btn-md">
                                            返回
                                        </Link>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/userEdit.js